<div class="modal-body width-800 height-900">
	<div class="layout-auto-1-auto">
    <span class="modal-header">
      {{enumSvc.getTranslation('ModalCoEditorComponent.Update')}}
    </span>
		<div class="content">
			<!-- loading Drawer -->
			<div *ngIf="oeUserList.isLoading" class="splash loading">
				<div class="spinner">
					<div></div>
					<div></div>
					<div></div>
					<div></div>
				</div>
			</div>
			<div class="layout-auto-1-auto">
				<exg-search-bar (Search)="oeUserList.search($event)" [placeholder]="getRessource('SearchHolder')"
				                class="span-layout">
					<ng-template #rightTemplate>
						<i (click)="oeUserList.loadData()" class="search-action fal fa-sync"></i>
					</ng-template>
				</exg-search-bar>
				<div class="content">
					<exg-data-table #VCoeUserList
					                (ItemSelect)="oeUserList.selectedRow"
					                [allowSingleSelection]="true"
					                [displayState]="0"
					                [hidden]="oeUserList.isLoading"
					                [rowSource]="oeUserList.data"
					                (RowChange)="oeUserList.selectionChanged($event)"
					                containerClass="grid cols-12 app-modal-co-editor"
					                selectKey="oeID">
						<ng-template #headerTemplate>
							<div class="span-4 typo-small">{{enumSvc.getTranslation('ModalCoEditorComponent.Name')}}</div>
							<div class="span-3 typo-small">{{enumSvc.getTranslation('ModalCoEditorComponent.Address')}}</div>
							<div class="span-5 typo-small">{{enumSvc.getTranslation('ModalCoEditorComponent.Comment')}}</div>
						</ng-template>
						<ng-template #rowTemplate let-row>
							<div class="span-4 typo-small">
								<span *ngIf="row.oeEName">{{row.oeEName}} </span>
								<span *ngIf="row.oeName">{{row.oeName}}</span>
							</div>
							<div class="span-3 typo-small">
								<span *ngIf="row.adrStr">{{row.adrStr}}</span>
								<span *ngIf="row.adrHNum"> {{row.adrHNum}}</span>
								{{row.adrStr && row.adrStr.length > 0 && row.adrOrt && row.adrOrt.length > 0 ? ',' : ''}}
								<span *ngIf="row.adrLkz"> {{row.adrLkz}}-</span><span *ngIf="row.adrPlz">{{row.adrPlz}}</span>
								<span *ngIf="row.adrOrt"> {{row.adrOrt}}</span>
							</div>
							<div class="span-5 typo-small">
								{{row.adrBez}}
							</div>
						</ng-template>
					</exg-data-table>
				</div>
				<exg-pager (PageChange)="oeUserList.pageChanged($event)" *ngIf="true"
				           [pagingSource]="oeUserList.paging">
				</exg-pager>
			</div>
		</div>
		<div class="spawn-modal-actions">
			<button class="md-btn" (click)="clickedSave()">Speichern</button>
			<button class="md-btn" (click)="clickedCancel()">Abbrechen</button>
		</div>
	</div>
</div>
